import {
  Button,
  Flex,
  Input,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import AlertModal from "../Modals/AlertModal";
import { formatDate } from "../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  createDeviationAPI,
  getDeviationAPI,
} from "../../Redux/App/app.actions";

const CreateDeviation = () => {
  const toast = useToast();
  const dispatch = useDispatch();
  const [deviation, setDeviation] = useState(null);
  const {
    isOpen: isOpen_create_deviation_modal,
    onOpen: onOpen_create_deviation_modal,
    onClose: onClose_create_deviation_modal,
  } = useDisclosure();

  const state = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.auth);
  let { response } = state;

  const handleChangeDeviation = (e, idx) => {
    let { name, value } = e.target;

    if (name === "start_date" || name === "end_date") {
      setDeviation((prev) => ({ ...prev, [name]: value }));
      return;
    }

    value = value !== "" ? Number(value) : value;
    let new_deviation = deviation.data.map((el, i) => {
      if (i === idx) {
        return { ...el, [name]: value };
      } else {
        return el;
      }
    });
    setDeviation((prev) => ({ ...prev, data: new_deviation }));
  };

  useEffect(() => {
    let initial_data = [];
    if (response?.output?.best_individual_burden?.length) {
      response.output.best_individual_burden.forEach((elem, idx) => {
        initial_data.push({
          "Lot no.": elem["Lot no."],
          "Value in burden sheet": elem["Qty used(Kgs)"],
          "Actual added": elem["Qty used(Kgs)"],
          Type: elem["Type"],
        });
      });
    }
    setDeviation((prev) => ({
      burden_sheet_id: state.response._id,
      burden_sheet_date: state.response.date,
      data: initial_data,
      start_date: "",
      end_date: "",
    }));
  }, [response]);

  const handleCreateDeviation = (payload) => {
    if (!deviation.start_date && !deviation.end_date) {
      toast({
        title: `please fill start and end date of the deviation`,
        status: "warning",
        isClosable: true,
      });
      return;
    } else if (!deviation.start_date) {
      toast({
        title: `please fill start date of the deviation`,
        status: "warning",
        isClosable: true,
      });
    } else if (!deviation.end_date) {
      toast({
        title: `please fill end date of the deviation`,
        status: "warning",
        isClosable: true,
      });
    } else if (
      new Date(deviation.start_date).getTime() >
      new Date(deviation.end_date).getTime()
    ) {
      toast({
        title: `Start date cannot be greater than end date`,
        status: "warning",
        isClosable: true,
      });
      return;
    } else {
      onOpen_create_deviation_modal();
    }
  };

  const handleConfirmCreateDeviation = () => {
    let payload = deviation;
    payload.created_on = new Date().toISOString();
    payload.created_by = user?.name || "";
    dispatch(createDeviationAPI(payload))
      .then((res) => {
        console.log("getting devation after creating");
        dispatch(getDeviationAPI());
      })
      .catch((err) => {
        console.log("getting devation after creating");
        dispatch(getDeviationAPI());
      });
  };

  return (
    <>
      <Flex w="100%" justify="left">
        <AlertModal
          onSubmit={handleConfirmCreateDeviation}
          onCancel={() => {
            console.log("cancelled creating a deviation");
          }}
          onClose={onClose_create_deviation_modal}
          isOpen={isOpen_create_deviation_modal}
          title={"Create a deviation"}
          body={"Are you sure, you want to create a new deviation?"}
        />
      </Flex>
      <Flex
        bg="gray.100"
        p="10px"
        w="100%"
        fontWeight="500"
        justify="space-between"
        align="center"
      >
        <Text fontSize="15px" color={"gray.600"}>
          Burden sheet date :{formatDate(state?.response?.date) || ""}
        </Text>
        <Text fontSize="15px" color={"gray.600"}>
          Burden sheet id : {state?.response?._id || ""}
        </Text>
        <Button
          colorScheme="green"
          onClick={() => handleCreateDeviation(deviation)}
        >
          Create deviation
        </Button>
      </Flex>
      <Flex m="10px 10px" w="50%" justifyContent="left" gap="1rem">
        <Flex direction={"column"}>
          <label htmlFor="start_date">Select start date</label>
          <Input
            value={deviation?.start_date || ""}
            name="start_date"
            onChange={handleChangeDeviation}
            id="start_date"
            placeholder="Select start date"
            size="md"
            type="datetime-local"
          />
        </Flex>
        <Flex direction="column">
          <label htmlFor="end_date">Select end date</label>
          <Input
            value={deviation?.end_date || ""}
            onChange={handleChangeDeviation}
            name="end_date"
            id="end_date"
            placeholder="Select end date"
            size="md"
            type="datetime-local"
          />
        </Flex>
      </Flex>
      {deviation != null && (
        <TableContainer>
          <Table size="sm" mt="1rem">
            <Thead>
              <Tr>
                <Th>Lot no.</Th>
                <Th>Type</Th>
                <Th>Value in burden sheet</Th>
                <Th>Actually added</Th>
              </Tr>
            </Thead>
            <Tbody>
              {deviation.data.map((elem, idx) => (
                <Tr
                  key={idx}
                  m="0"
                  p="0"
                  bg={
                    elem["Actual added"] != elem["Value in burden sheet"]
                      ? "orange.200"
                      : "none"
                  }
                >
                  <Td>{elem["Lot no."]}</Td>
                  <Td>{elem["Type"]}</Td>
                  <Td>{elem["Value in burden sheet"]}</Td>
                  <Td p="0">
                    <Input
                      h="35px"
                      borderRadius="0"
                      m="0"
                      value={elem["Actual added"]}
                      name="Actual added"
                      type="number"
                      placeholder="enter actual added value"
                      onChange={(e) => handleChangeDeviation(e, idx)}
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => e.target.blur()}
                      onScroll={(e) => e.target.blur()}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default CreateDeviation;
